export enum WindowActionType {
  EnterFullscreen = '[Window] EnterFullscreen',
  EnterFullscreenFailure = '[Window] EnterFullscreenFailure',
  EnterFullscreenSuccess = '[Window] EnterFullscreenSuccess',
  ExitFullscreen = '[Window] ExitFullscreen',
}
